export const formatTeamsData = (teamFilterValues) => {
  let formattedOptions = [];

  if (
    teamFilterValues &&
    teamFilterValues !== "" &&
    (Array.isArray(teamFilterValues) ||
      teamFilterValues.hasOwnProperty("parentChildrenTeamFilter"))
  ) {
    const getTeamsData = (filters) => {
      if (Array.isArray(filters)) {
        const parentChildrenTeamFilter = filters.find((filter) =>
          filter.hasOwnProperty("parentChildrenTeamFilter")
        );
        return parentChildrenTeamFilter
          ? parentChildrenTeamFilter.parentChildrenTeamFilter
          : filters;
      } else {
        return filters.parentChildrenTeamFilter || filters.teams || [];
      }
    };

    const flattenTeams = (teams, parentValue = null, indent = 0) => {
      if (!Array.isArray(teams)) {
        return [];
      }

      return teams.reduce((acc, team) => {
        const isParent = Array.isArray(team.teams) && team.teams.length > 0;
        const currentParentValue = parentValue || team.Parent;
        const teamOption = {
          label: team.Parent,
          value: currentParentValue,
          parentValue: parentValue,
          isParent: isParent,
          indent: indent,
        };

        const childOptions = isParent
          ? flattenTeams(team.teams, currentParentValue, indent + 1)
          : [];

        return [...acc, teamOption, ...childOptions];
      }, []);
    };

    const teamsData = getTeamsData(teamFilterValues);
    formattedOptions = flattenTeams(teamsData);
  } else {
    console.log("Invalid or empty teamFilterValues");
  }

  return formattedOptions;
};
